import { getDataFromPocket } from '../../utils/pocket';

/* eslint-disable no-underscore-dangle */

export function monkeyPatchVWO() {
    window.VWO_OUTCOME = 'pending';

    // to store a flag of "vwo redirect happened on the previous url"
    const VWO_EVENT_SESSION_KEY = 'VWO_REDIRECT';

    const vwoOpts = getDataFromPocket<{ enabled: boolean }>('vwo_opts', false);
    if (!vwoOpts?.enabled) {
        window.VWO_OUTCOME = 'regular';
    }

    const vwoFlag = window.sessionStorage.getItem(VWO_EVENT_SESSION_KEY);
    if (vwoFlag === 'true') {
        window.sessionStorage.removeItem(VWO_EVENT_SESSION_KEY);
        window.VWO_OUTCOME = 'regular';
    }

    // monkey patch .push() method to capture redirect flag
    window._vwo_evq = window._vwo_evq || [];

    const vwoPushOriginal = window._vwo_evq.push;

    window._vwo_evq.push = (...args: unknown[]): number => {
        const eventData = args[0] as string[];

        if (eventData[0] === 'rD') {
            // It will be set to true if a redirection is going to be done by VWO.
            const willRedirectionOccur = eventData[1];
            window.VWO_OUTCOME = willRedirectionOccur ? 'redirect' : 'regular';

            if (willRedirectionOccur) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ vwoRedirect: 'true' });
                window.sessionStorage.setItem(VWO_EVENT_SESSION_KEY, 'true');
            }
        }

        return vwoPushOriginal.apply(window._vwo_evq, [].slice.call(args));
    };
}

export function initVWO() {
    if (typeof window._vwo_code?.init !== 'function') {
        window.VWO_OUTCOME = 'regular';
        return;
    }

    window._vwo_code.init();
}
